import { useCallback } from "react";

import { useGenerateAiInterviewQuestionEvaluationMutation } from "../../graphql";
import { useAiInterviewerContext } from "./AiInterviewerContext";
import { useAiInterviewerFormContext } from "./useAiInterviewerFormContext";

const useGenerateQuestionEvaluation = (
  index: number
): {
  generateQuestionEvaluation: () => Promise<void>;
  loading: boolean;
} => {
  const aiInterviewer = useAiInterviewerContext();
  const { setValue, getValues } = useAiInterviewerFormContext();

  const [generateEvaluationMutation, { loading }] =
    useGenerateAiInterviewQuestionEvaluationMutation();

  const generateQuestionEvaluation = useCallback(async () => {
    const formValues = getValues();
    const variables = {
      aiInterviewerId: aiInterviewer.id,
      aiInterviewerName: formValues.name,
      questions: formValues.questions.map(
        ({ sortOrder, __typename, originalQuestionId, ...rest }) => ({
          ...rest,
        })
      ),
      positionInfo: formValues.positionInfo,
      introduction: formValues.introduction,
      closing: formValues.closing,
      jobDescription: formValues.jobDescription,
      targetQuestionPosition: index,
    };
    const result = await generateEvaluationMutation({ variables });
    const updated =
      result.data?.generateAiInterviewQuestionEvaluation?.aiInterviewQuestion;
    if (updated) {
      (
        [
          "question",
          "type",
          "rubric",
          "qualificationCriteria",
          "summaryCriteria",
        ] as const
      ).forEach((key) => {
        const fieldPath = `questions.${index}.${key}` as const;
        if (key in updated) {
          setValue(fieldPath, updated[key], {
            shouldDirty: true,
          });
        }
      });
    }
  }, [
    aiInterviewer.id,
    setValue,
    getValues,
    index,
    generateEvaluationMutation,
  ]);

  return { generateQuestionEvaluation, loading };
};

export default useGenerateQuestionEvaluation;
